import React, { useEffect, useState } from "react";
import { Spinner, ProgressBar } from "react-bootstrap";

interface Props {
  isActive: boolean;
}

export const FakeProgressBar: React.FC<Props> = ({ isActive }) => {
  const [progressPercent, setProgressPercent] = useState(0);

  useEffect(() => {
    if (!isActive) {
      setProgressPercent(0);
      return;
    }

    const totalDuration = 6 * 60 * 1000; // 6 minutes
    const updateInterval = 1000; // 1s
    const steps = totalDuration / updateInterval;
    let currentStep = 0;

    const interval = setInterval(() => {
      currentStep++;
      setProgressPercent(Math.min((currentStep / steps) * 100, 100));
    }, updateInterval);

    return () => clearInterval(interval);
  }, [isActive]);

  if (!isActive) return null;

  return (
    <>
      {/* Centered spinner */}
      <div className="position-absolute top-50 start-50 translate-middle text-center text-light">
        <Spinner animation="border" variant="light" />
      </div>

      {/* Bottom progress bar */}
      <div className="position-absolute bottom-0 start-0 end-0 px-2 pb-2">
        <ProgressBar
          now={progressPercent}
          variant="info"
          animated
          striped
          style={{ height: "6px" }}
        />
      </div>
    </>
  );
};
